import { render, staticRenderFns } from "./GenAITagCreate.vue?vue&type=template&id=23983a30&"
import script from "./GenAITagCreate.vue?vue&type=script&lang=js&"
export * from "./GenAITagCreate.vue?vue&type=script&lang=js&"
import style0 from "./GenAITagCreate.vue?vue&type=style&index=0&id=23983a30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports